/*
  this file is used to define common parameters for vue-i18n
*/

import { useI18n as actualUseI18n} from 'vue-i18n'

export function useI18n() {
  return actualUseI18n({useScope: 'global'});
}
